import React from 'react'
import './BlogWidget.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons'
import blogsData from '../data'
import { Link } from 'react-router-dom';

const BlogWidget = () => {
    
    return (
        <section className="all-blog-widget-section">
            <div className="container">
                <div className="blog-widget-main">
                    {/* {/* === Blog Item Loop === */ 
                        blogsData.map((blog, blogIndex) => {
                            return(
                                <div className="blog-item-box" key={`BLOG${blogIndex}SUYFI4392HIS`}>
                                    {/* === Image Box ===  */
                                    blog.featureImage &&
                                    <div className="item-img-box" style={{backgroundImage: `url(${blog.featureImage})`, height: `${300}px`}}>
                                        <Link to={blog.postUrl} className="item-img-link" style={{paddingTop: `${blog.featureImageHight/2-20}px`}}>
                                            <FontAwesomeIcon icon={faLongArrowAltRight} />
                                        </Link>
                                    </div>}
                                    {/* === Item information ===  */}
                                    <div className="item-info-box">
                                        <Link to={blog.postUrl} className="item-title-link">
                                            <h3 className="item-title" title={blog.title}>{blog.title}</h3>
                                        </Link>
                                        <div className="author-info">
                                            <div className="author-avatar">
                                                <img src={blog.authorAvatar} alt="author name" />
                                            </div>
                                            <div className="author-description">
                                                <h5 className="authore-name">{blog.authorName}</h5>
                                                <p className="publish-date">{blog.postDate}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                        // === Item loop end ===
                    }
                </div>
            </div>
        </section>
    )
}

export default BlogWidget
